import type { DEFAULT_FLEXIBLE_DURATION_RANGE } from 'constants/search'
import { encodeSearchParams } from 'lib/search/searchUtils'

export function getRecentSearchUrl(recentSearch: App.FullRecentSearch) {
  const { dates, rooms } = recentSearch
  const queryParams = encodeSearchParams({
    flexibleMonths: dates?.flexibleMonths,
    flexibleNights: dates?.flexibleDuration as DEFAULT_FLEXIBLE_DURATION_RANGE,
    dates: {
      checkIn: dates.checkIn,
      checkOut: dates.checkOut,
    },
    urlSearch: '',
    rooms,
    searchItem: recentSearch.searchItem,
    userSelectedFlexibleMonths: !!dates?.flexibleMonths,
  }).toString()

  return `/search?${queryParams}`
}
